import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
const defaultProps = {
    activeTab: 0,
    index: 0,
    label: '',
    onClick: () => { },
};
const selectedTabBorderWidth = styleUtils.rem(2);
const TabbedContainerTab = ({ activeTab = defaultProps.activeTab, index = defaultProps.index, label = defaultProps.label, onClick = defaultProps.onClick, }) => {
    const onTabClick = () => {
        onClick(index);
    };
    const buttonStyles = useMemo(() => (css `
        ${styleUtils.buttonReset}
        ${theme.typeStyles.captionMediumStyles}
        border-bottom-color: transparent;
        border-bottom-style: solid;
        border-bottom-width: ${selectedTabBorderWidth};
        color: ${theme.colors.gray600};
        cursor: pointer;
        height: ${theme.spacing.x12};
        list-style: none;
        margin-bottom: 0;
        margin-left: 0;
        margin-right: 0;
        margin-top: 0;
        width: 100%;

        &:hover {
          color: ${theme.colors.gray700};
        }

        ${activeTab === index && css `
          border-color: ${theme.colors.gray700};
          color: ${theme.colors.gray700};
        `}
      `), [
        activeTab,
        index,
    ]);
    return (_jsx("button", Object.assign({ css: buttonStyles, onClick: onTabClick, type: "button" }, { children: label })));
};
const MemoizedTabbedContainerTab = memo(TabbedContainerTab);
export { MemoizedTabbedContainerTab as TabbedContainerTab };
// MC-1068 Temporary hack for Storybook.
export default TabbedContainerTab;
